import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { SimpleTooltip } from "simple-ui-components";

import DashboardIcon from "@mui/icons-material/Dashboard";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import LocationSearchingIcon from "@mui/icons-material/LocationSearching";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BuildIcon from "@mui/icons-material/Build";
import DriveEtaIcon from "@mui/icons-material/DriveEta";

import { getTranslation } from "../languageProvider";

export const Navigation = () => {
  const { Tooltip } = SimpleTooltip;
  return (
    <NavigationStyled>
      <div className="menu">
        <NavLink to={"/dashboard"} activeclassname={"active"}>
          <Tooltip text={getTranslation("0007")} placement="right" click>
            <DashboardIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/equipments"} activeclassname={"active"}>
          <Tooltip text={`${getTranslation("0071")}s`} placement="right" click>
            <DevicesOutlinedIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/clients"} activeclassname={"active"}>
          <Tooltip text={`${getTranslation("0072")}s`} placement="right" click>
            <PeopleOutlineIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/accounts"} activeclassname={"active"}>
          <Tooltip text={`${getTranslation("0073")}s`} placement="right" click>
            <PeopleAltIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/vehicles"} activeclassname={"active"}>
          <Tooltip text={`${getTranslation("0173")}`} placement="right" click>
            <DriveEtaIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/routes"} activeclassname={"active"}>
          <Tooltip text={`${getTranslation("0008")}s`} placement="right" click>
            <LocationSearchingIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/repairs"} activeclassname={"active"}>
          <Tooltip text={getTranslation("0074")} placement="right" click>
            <BuildIcon />
          </Tooltip>
        </NavLink>
        <NavLink to={"/reports"} activeclassname={"active"}>
          <Tooltip text={getTranslation("0075")} placement="right" click>
            <ChromeReaderModeIcon />
          </Tooltip>
        </NavLink>
      </div>
    </NavigationStyled>
  );
};

const NavigationStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    flex-direction:column;
    align-items:center;
    width:56px;
    min-width:56px;
    border-right:1px solid rgba(${current.black},0.3);
    ${
      props.isOpen &&
      `width:240px;
      min-width:240px;
    `
    };
    align-items: stretch;
    background:rgb(${current.white});
    .menu{
      position:fixed;
      width:56px;
      min-width:56px;
      ${
        props.isOpen &&
        `width:240px;
        min-width:240px;
        `
      };
      a{
        display:flex;
        justify-content: center;
        margin-bottom:${current.gSM};
        ${
          props.isOpen &&
          `
        justify-content: flex-start;
        >svg{
          margin-right:${current.gSM};
        }
        `
        };
        >span>svg{
          width:100%;
          padding:${current.gMD} ${current.gLG};
          font-size:46px;
        }
        
        color:rgb(${current.cOne});
        align-items:center;

        :hover{
          background:rgba(${current.black},0.3);
          color:rgb(${current.white});
        }
      }
      a.active{
        background:rgba(${current.black},0.3);
        color:rgb(${current.white});
      }
    }
    `;
  }}
`;
